import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import { Geist, Geist_Mono, Playfair_Display } from 'next/font/google'

const geistSans = Geist({
    variable: '--font-geist-sans',
    subsets: ['latin']
})

const geistMono = Geist_Mono({
    variable: '--font-geist-mono',
    subsets: ['latin']
})

const playfair = Playfair_Display({
    variable: '--font-playfair',
    subsets: ['latin']
})

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className={`${geistSans.variable} ${geistMono.variable} ${playfair.variable} h-full font-sans antialiased`}>
            <Component {...pageProps} />
        </div>
    )
}

export default App
